function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4348 1.22183C13.0442 0.831302 12.4111 0.831302 12.0206 1.22183L7.07081 6.17157C6.28976 6.95262 6.28976 8.21895 7.07081 9L13.4348 2.63604C13.8253 2.24551 13.8253 1.61235 13.4348 1.22183Z",
  fill: "#9FAFB9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.706985 1.22192C0.316462 1.61244 0.316462 2.24561 0.706985 2.63613L7.07081 9C7.85186 8.21895 7.85186 6.95262 7.07081 6.17157L2.1212 1.22192C1.73067 0.831394 1.09751 0.831394 0.706985 1.22192Z",
  fill: "#9FAFB9"
});

var SvgTxExpand = function SvgTxExpand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTxExpand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tx-expand.3e61e059.svg";
export { ForwardRef as ReactComponent };